module.exports = __webpack_public_path__ + "media/images/logo-ansi-72e2e861e081d047fc3d83b0b10656e4.png";